import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 bg-white letter-spacing"
}
const _hoisted_2 = { class: "card-header d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "col-md-3 mb-2" }
const _hoisted_7 = { class: "text-black fw-semibold" }
const _hoisted_8 = { class: "col-md-3 mb-2" }
const _hoisted_9 = { class: "text-black fw-semibold" }
const _hoisted_10 = { class: "col-md-3 mb-2" }
const _hoisted_11 = { class: "text-black fw-semibold" }
const _hoisted_12 = { class: "col-md-3 mb-2" }
const _hoisted_13 = { class: "text-black fw-semibold" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = { class: "col-md-3 mb-2" }
const _hoisted_16 = { class: "text-black fw-semibold" }
const _hoisted_17 = { class: "col-md-3 mb-2" }
const _hoisted_18 = { class: "text-black fw-semibold" }
const _hoisted_19 = { class: "col-md-3 mb-2" }
const _hoisted_20 = { class: "text-black fw-semibold" }
const _hoisted_21 = { class: "border border-primary mb-3" }
const _hoisted_22 = { class: "table-responsive" }
const _hoisted_23 = { class: "table align-middle mb-0" }
const _hoisted_24 = { class: "fw-medium" }
const _hoisted_25 = { class: "fw-medium description-cell" }
const _hoisted_26 = { class: "fw-medium text-nowrap" }
const _hoisted_27 = { class: "fw-medium text-nowrap" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.commande)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createTextVNode(" Commande fournisseur " + _toDisplayString(_ctx.commande.refCom) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["badge ms-2", _ctx.classeStatut(_ctx.commande.statut)])
            }, _toDisplayString(_ctx.libelleStatut(_ctx.commande.statut)), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Date", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.format_date(_ctx.commande.dateComFrs)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Fournisseur", -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.libelleFournisseur(_ctx.commande.fournisseur)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Point de vente", -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.commande.pointvente?.nomPointVente), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Poids total", -1)),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatPoids(_ctx.commande.poidsTotal)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Conducteur", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.commande.nomConducteur || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Téléphone du conducteur", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.commande.telephoneConducteur || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-body-tertiary fs-13 text-uppercase" }, "Immatriculation du véhicule", -1)),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.commande.immatriculationVehicule || '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row py-2 bg-primary mx-0" }, [
              _createElementVNode("h4", { class: "fs-4 text-white mb-0" }, "Les produits")
            ], -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("table", _hoisted_23, [
                _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13" }, "Produit"),
                    _createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 col-description" }, "Description"),
                    _createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 text-nowrap" }, "Quantité"),
                    _createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 text-nowrap" }, "Poids")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lignes, (ligne) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: ligne.id
                    }, [
                      _createElementVNode("td", _hoisted_24, _toDisplayString(ligne.nomProd), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(ligne.description || '-'), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(ligne.qteComfrs), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatPoids(ligne.poids)), 1)
                    ]))
                  }), 128)),
                  (_ctx.lignes.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_28, _cache[9] || (_cache[9] = [
                        _createElementVNode("td", {
                          colspan: "4",
                          class: "text-center text-body-tertiary py-3"
                        }, "Aucun produit.", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.estEnAttente)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.checkPermission('EditCommandeFournisseur'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'EditCommandeFournisseurPage', params: { id: _ctx.commande.id } },
                        class: "btn btn-primary me-3"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "flaticon-pen lh-1 me-1 position-relative top-1" }, null, -1),
                          _createTextVNode("Modifier ")
                        ])),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_ctx.checkPermission('ValiderCommandeFournisseur'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-success me-3",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.valider && _ctx.valider(...args)))
                      }, _cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fa fa-check lh-1 me-1" }, null, -1),
                        _createTextVNode("Valider ")
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.checkPermission('RejeterCommandeFournisseur'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-danger me-3",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejeter && _ctx.rejeter(...args)))
                      }, _cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fa fa-ban lh-1 me-1" }, null, -1),
                        _createTextVNode("Rejeter ")
                      ])))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: 'ListCommandesFournisseursPage' },
              class: "btn btn-secondary"
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode(" Retour à la liste ")
              ])),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}